var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"300","flat":""}},[_c('v-snackbar',{attrs:{"timeout":-1,"color":"white"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }